import * as types from './types';

// Change Lang
export function changeLang(lang){
    return {
        type: types.CHANGE_LANG,
        lang
    }
}